import React from 'react'
import styled, { css } from 'styled-components'

type Props = {
  bgColor?: string
  bgGradient?: CardBgGradients
  shadow?: boolean
  border?: boolean
  padding?: string
  mobilePadding?: string
  minHeight?: string
  className?: string
}

export type CardBgGradients = 'red' | 'green' | 'blue' | 'orange_yellow'

export const Card = ({
  bgColor,
  bgGradient,
  shadow,
  border,
  padding,
  mobilePadding,
  minHeight,
  children,
  className,
}: WithChildren<Props>): JSX.Element => {
  return (
    <CardWrapper
      bgColor={bgColor}
      bgGradient={bgGradient}
      shadow={shadow}
      border={border}
      padding={padding}
      mobilePadding={mobilePadding}
      minHeight={minHeight}
      className={className}
    >
      {children}
    </CardWrapper>
  )
}

type CardWrapperProps = {
  bgColor?: string
  bgGradient?: CardBgGradients
  shadow?: boolean
  border?: boolean
  minHeight?: string
  padding?: string
  mobilePadding?: string
}

const getGradientVariant = ({ bgGradient }: CardWrapperProps) => {
  switch (bgGradient) {
    case 'red':
      return css`
        background: linear-gradient(156.8deg, #963131 -9.92%, #ff6666 102.65%);
      `
    case 'orange_yellow':
      return css`
        background: linear-gradient(156.8deg, #bb5a00 -9.92%, #ffd427 102.65%);
      `
    case 'blue':
      return css`
        background: linear-gradient(133.15deg, #01579b -1.28%, #00b0ff 72.43%);
      `

    case 'green':
      return css`
        background: linear-gradient(156.8deg, #1b5e20 -9.92%, #83d200 102.65%);
      `
    default:
      return css``
  }
}

const CardWrapper = styled.div<CardWrapperProps>`
  background-color: ${({ bgColor }) => bgColor || 'white'};
  padding: ${({ mobilePadding, padding }) =>
    mobilePadding || padding || '2rem'};

  box-shadow: ${({ theme, shadow }) => (shadow ? theme.shadow.espansa : '')};
  border: ${({ theme, border }) =>
    border ? `2px solid ${theme.color.neutri.grigioBg};` : ''};

  min-height: ${({ minHeight }) => minHeight ?? null};

  border-radius: 20px 20px 20px 20px;

  @media (min-width: ${({ theme }) => theme.bp.desktop}) {
    padding: ${({ padding }) => padding || '2rem'};
  }

  ${getGradientVariant};
`
